import { Injectable, ElementRef } from '@angular/core';
import { Helpers } from '../helpers';

@Injectable()
export class DatatableService {
    public dataType: string;
    private config: IDatatableConfig;
    public dtoptions;
    public datatable: any;

    constructor() { }

    setConfig(this: DatatableService, config: IDatatableConfig) {
        if (config.localData != null) {
            this.dataType = 'local';
        } else if (config.remoteUrl != null) {
            this.dataType = 'remote';
        }
        if (!config.pagesize) config.pagesize = 20;
        if (!config.selectorId) config.selectorId = 'datatable';
        if (config.actionConfig) {
            let actionColumn = this.getActionColumn(config.actionConfig);
            config.columns.push(actionColumn);
        }
        this.config = config;
        return this;
    }

    private getActionColumn(config: IActionConfig) {
        return {
            field: 'Actions',
            width: 80,
            title: 'Actions',
            sortable: false,
            overflow: 'visible',
            textAlign: 'center',
            template: function(row, index, datatable) {
                let templateHtml = '';
                if (config.update === true) {
                    templateHtml +=
                        '<button data-id="' +
                        row.id +
                        '" id="update' +
                        row.id +
                        '" class="update-row m-datatable--on-layout-updated m-portlet__nav-link btn m-btn m-btn--hover-accent m-btn--icon m-btn--icon-only m-btn--pill" title="Edit "><i class="la la-edit"></i></button>';
                }
                if (config.delete === true) {
                    templateHtml +=
                        '<button data-id="' +
                        row.id +
                        '" id="delete' +
                        row.id +
                        '" class="delete-row m-portlet__nav-link btn m-btn m-btn--hover-danger m-btn--icon m-btn--icon-only m-btn--pill" title="Delete "><i class="la la-trash"></i></button>';
                }
                return templateHtml;
            }
        };
    }

    private getDataSource(dataType) {
        var source = {};
        if (dataType == 'remote') {
            var apiEndpoint = Helpers.getApiEndpoint();
            var token = Helpers.getAccessToken();
            source = {
                read: {
                    url: apiEndpoint + this.config.remoteUrl,
                    method: 'GET',
                    headers: {
                        Authorization: 'Bearer ' + token
                    }
                }
            };
        } else if (dataType == 'local') {
            source = this.config.localData;
        }
        return source;
    }

    public build(this: DatatableService) {
        if (this.config.checkboxColumn === true) {
            this.config.columns.unshift({
                field: 'id',
                title: '#',
                sortable: false,
                width: 20,
                selector: { class: 'm-checkbox--solid m-checkbox--brand' }
            });
        }
        this.dtoptions = {
            data: {
                type: this.dataType,
                source: this.getDataSource(this.dataType),
                map: function(raw) {
                    var dataSet = raw;
                    if (typeof raw.data !== 'undefined') {
                        dataSet = raw.data;
                    }
                    return dataSet;
                },
                pageSize: this.config.pagesize,
                serverPaging: false,
                serverFiltering: false,
                serverSorting: false
            },
            layout: {
                theme: 'default',
                class: this.config.tableClass ? this.config.tableClass : '',
                height: 'auto',
                footer: false
            },
            pagination:
            this.config.pagination != null ? this.config.pagination : true,
            sortable: true,
            toolbar: {
                placement: ['bottom'],
                items: {
                    pagination: {
                        pageSizeSelect: [20, 50, 100, 500]
                    }
                }
            },
            fixedColumns: {
                leftColumns: 2
            },
            search: {
                onEnter: false,
                input: $('#generalSearch'),
                delay: 400
            },
            columns: this.config.columns
        };
        this.removeDatatable(this.config.selectorId);
        let selector = '#' + this.config.selectorId;
        var datatableSelectorId = this.config.selectorId + '-datatable';
        var datatableSelector = '#' + datatableSelectorId;
        (<any>$(selector))
            .css('width', '100%')
            .append('<table id="' + datatableSelectorId + '"></table>');

        this.datatable = (<any>$(datatableSelector)).mDatatable(this.dtoptions);
        return this;
    }

    getSelectedRowIds() {
        var ids = this.datatable
            .rows('.m-datatable__row--active')
            .nodes()
            .find('.m-checkbox--single > [type="checkbox"]')
            .map(function(i, chk) {
                return $(chk).val();
            });
        let selectedItemIds = [];
        for (var i = 0; i < ids.length; i++) {
            let id = ids[i];
            selectedItemIds.push(id);
        }
        return selectedItemIds;
    }

    public setDataSourceParam(key, value) {
        if (this.datatable) this.datatable.setDataSourceParam(key, value);
    }

    public reload(params: IDataSourceParam[] = []) {
        params.forEach(param => {
            this.datatable.setDataSourceParam(param.key, param.value);
        });
        this.datatable.load();
    }

    public refreshDatatable() {
        this.datatable.load();
    }

    public removeDatatable(selectorId) {
        let selector = '#' + selectorId;
        (<any>$(selector)).empty();
    }

    public onClickDelete(
        event: any,
        el: ElementRef,
        onClickDeleteTrigger: Function
    ) {
        this.onClick(event, el, onClickDeleteTrigger, 'delete-row');
    }

    public onClickUpdate(
        event: any,
        el: ElementRef,
        onClickUpdateTrigger: Function
    ) {
        this.onClick(event, el, onClickUpdateTrigger, 'update-row');
    }

    public onClick(
        event: any,
        el: ElementRef,
        onClickTrigger: Function,
        selectorClass: string
    ) {
        let e = <any>event;
        try {
            if (e.target.offsetParent.classList.contains(selectorClass)) {
                var id = (<any>event).target.offsetParent.id;
                let item = el.nativeElement.querySelector('#' + id);
                if (item != null && item.classList.contains(selectorClass)) {
                    let id = item.getAttribute('data-id');
                    onClickTrigger(id);
                }
            } else if (e.target.classList.contains(selectorClass)) {
                var id = (<any>event).target.id;
                let item = el.nativeElement.querySelector('#' + id);
                if (item != null && item.classList.contains(selectorClass)) {
                    let id = item.getAttribute('data-id');
                    onClickTrigger(id);
                }
            }
        } catch (e) { }
    }
}

export interface IDatatableConfig {
    selectorId?: string;
    localData?: any[];
    remoteUrl?: string;
    pagesize?: number;
    columns: any[];
    actionConfig?: IActionConfig;
    checkboxColumn?: boolean;
    tableClass?: string;
    pagination?: boolean;
}

export interface IActionConfig {
    update?: boolean;
    delete?: boolean;
    info?: boolean;
}

export interface IDataSourceParam {
    key: any;
    value: any;
}



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/_services/datatable.service.ts